import { TextButton } from '@widgets/GenericBookings/components/AttendeesSelector/styles';
import styled from 'styled-components';
export const Link = styled(TextButton) `
  color: var(--primary-light);
  cursor: pointer;
`;
export const Text = styled.h4 `
  margin-bottom: .5rem;
  ${({ theme: { noSessionText } }) => noSessionText}
`;
export const Wrapper = styled.div `
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
export default {
    Wrapper,
    Text,
    Link,
};
